export default "__VITE_ASSET__27d12c77__"